import React from "react";
import { activeDialogState } from "../../redux/slices/dialogsSlice";
import { useSelector } from "react-redux";
import { GlobalVariables } from "../../GlobalVariables";
import { ReduxUpdater } from "../../redux/ReduxUpdater";

const ConfirmDialog = () => {
    const currentActiveDialogState =  useSelector(activeDialogState);
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        // Optional: close on ESC
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") setOpen(false);
        }; 
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    React.useEffect(() => {
        console.log('ConfirmDialog:', currentActiveDialogState === 'confirmAction', GlobalVariables.dialogConfig);
        setOpen(currentActiveDialogState === 'confirmAction');
    }, [currentActiveDialogState]);

    const handleClose = () => {
        ReduxUpdater.currentDialog = null;
    };

    return (
        <div>
            {open && (
                <div className="hs-overlay fixed inset-0 z-[60] overflow-y-auto bg-gray-900/50 p-4">
                    <div className="mx-auto mt-10 max-w-xl">
                        <div className="relative grid grid-cols-1 overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-200 md:grid-cols-12">
                            {/* Close */}
                            <button
                                type="button"
                                onClick={handleClose}
                                className="absolute right-3 top-3 inline-flex size-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-amber-500"
                                aria-label="Close"
                            >
                                <svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6 6 18M6 6l12 12"/></svg>
                            </button>

                            <section className="col-span-12 mx-10 my-12">
                                <span className="text-xl font-medium">{GlobalVariables.dialogConfig.title}</span>
                                <p className="text-sm text-justify my-4">{GlobalVariables.dialogConfig.content}</p>
                                <div className="w-full h-8 py-2 text-text-primary inline-flex justify-start items-center gap-2.5">
                                    {GlobalVariables.dialogConfig.textConfirm &&  <button
                                        className="flex-1 h-10 px-3 bg-buttons-primary rounded-lg flex justify-center items-center gap-2.5 disabled:opacity-50 disabled:pointer-events-none"
                                        onClick={GlobalVariables.dialogConfig.onConfirm}
                                    >
                                        <div className="flex-1 text-center justify-start text-text-dark-invert text-sm font-semibold font-['Inter'] leading-tight">{GlobalVariables.dialogConfig.textConfirm}</div>
                                    </button>}
                                    <button
                                        className="flex-1 h-10 px-3 bg-buttons-primary rounded-lg flex justify-center items-center gap-2.5 disabled:opacity-50 disabled:pointer-events-none"
                                        onClick={GlobalVariables.dialogConfig.onCancel ?? handleClose}
                                    >
                                        <div className="flex-1 text-center justify-start text-text-dark-invert text-sm font-semibold font-['Inter'] leading-tight">{GlobalVariables.dialogConfig.textCancel}</div>
                                    </button>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ConfirmDialog;
